const MAKE_AN_OFFER = 'make_an_offer';
const TOTAL_ASKING_PRICE = 'total_asking_price';
const ASKING_PRICE_PER_HECTARE = 'asking_price_per_hectare';

const LEASE_LAND = 'lease_land';
const LEASE_CO2 = 'lease_co2';

const TREE_SEGMENTATION = 'TREE_SEGMENTATION';
const TREE_AREA = 'TREE_AREA';
const TREE_HEIGHT_DISTRIBUTION = 'TREE_HEIGHT_DISTRIBUTION';
const CARBON_STOCK_ESTIMATION = 'CARBON_STOCK_ESTIMATION';
const SUCCESS = 'SUCCESS';

const IRELAND_COORDINATES = [53.33260179774514, -7.991799869452587];

export {
  MAKE_AN_OFFER,
  TOTAL_ASKING_PRICE,
  ASKING_PRICE_PER_HECTARE,
  LEASE_LAND,
  LEASE_CO2,
  TREE_SEGMENTATION,
  TREE_AREA,
  TREE_HEIGHT_DISTRIBUTION,
  CARBON_STOCK_ESTIMATION,
  SUCCESS,
  IRELAND_COORDINATES
};
